import { render, staticRenderFns } from "./welcomeLanguage.vue?vue&type=template&id=e08f7562"
import script from "./welcomeLanguage.vue?vue&type=script&lang=js"
export * from "./welcomeLanguage.vue?vue&type=script&lang=js"
import style0 from "./welcomeLanguage.vue?vue&type=style&index=0&id=e08f7562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports